module.exports = __webpack_public_path__ + "img/directdebit.bc28b273.svg";